import React from 'react';
import { useSelector } from 'react-redux';

import accountSelectors from '../../pages/AccountSelection/selectors';
import { CheckOut } from '../../types';
import FieldLabelAndValue from '../FieldLabelAndValue';
import FieldValue from '../FieldValue';
import { formatAbn, formatSupplierTerm } from '../../lib/formatter';
import DollarAndCentsText from '../DollarAndCentsText';

interface Props {
  checkout: CheckOut;
}

const ShiftTradeCheckoutSummary = (props: Props) => {
  const { checkout } = props;
  const supplierBuyerAssociation = useSelector(accountSelectors.selectSupplierBuyerAssociation);

  return (
    <>
      <FieldLabelAndValue label='Merchant' dataTestId='uia-merchantAccount'>
        <FieldValue dataTestId='uia-merchantAccountName'>{checkout.accountName}</FieldValue>
        <FieldValue dataTestId='uia-merchantAbn'>{`ABN: ${formatAbn(checkout.abn)}`}</FieldValue>
      </FieldLabelAndValue>
      <FieldLabelAndValue label='Invoice Amount' dataTestId='uia-amount'>
        <FieldValue dataTestId='uia-amount'>
          <DollarAndCentsText amount={checkout.amount} />
        </FieldValue>
      </FieldLabelAndValue>
      {supplierBuyerAssociation && (
        <FieldLabelAndValue label='Term' dataTestId='uia-term'>
          <FieldValue dataTestId='uia-term'>{formatSupplierTerm(supplierBuyerAssociation.term, supplierBuyerAssociation.termPeriod)}</FieldValue>
        </FieldLabelAndValue>
      )}
    </>
  );
};

export default ShiftTradeCheckoutSummary;
